module.exports = __webpack_public_path__ + "static/img/cjfw-companyProducts1.b77bbc24.png";